import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgComponent } from '@components/svg.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-navbar-button',
  standalone: true,
  imports: [
    CommonModule,
    SvgComponent,
    TranslateModule,
    RouterLink,
    RouterLinkActive,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="w-full">
      @if (url && url !== '') {
        <a
          #rla="routerLinkActive"
          [routerLinkActive]="'bg-vert-1'"
          [routerLink]="url"
          [class.px-4]="!isCollapsed"
          [class.justify-center]="isCollapsed"
          class="w-full flex items-center gap-4 border rounded border-noir-2-contour py-2 bg-noir-2 transition-all cursor-pointer hover:opacity-70 block no-underline"
          (click)="onClick.emit()"
        >
          @if (svgType === 'svg') {
            <app-svg
              [svgPath]="'/assets/svg/' + svgName + '.svg'"
              [ngClass]="{
                'fg-vert-1': !rla.isActive,
                'text-white': rla.isActive,
              }"
            ></app-svg>
          } @else if (svgType === 'material') {
            <span
              class="material-icons !text-md"
              [ngClass]="{
                'fg-vert-1': !rla.isActive,
                'text-white': rla.isActive,
              }"
            >
              {{ svgName }}
            </span>
          } @else if (svgType === 'material-symbols-outlined') {
            <span
              class="material-symbols-outlined !text-md "
              [ngClass]="{
                'fg-vert-1': !rla.isActive,
                'text-white': rla.isActive,
              }"
            >
              {{ svgName }}
            </span>
          }
          @if (!isCollapsed) {
            <span class="text-white text-xs font-semibold">{{
              label | translate
            }}</span>
          }
        </a>
      } @else {
        <div
          [class.px-4]="!isCollapsed"
          [class.justify-center]="isCollapsed"
          class="w-full flex items-center gap-4 border rounded border-noir-2-contour py-2 bg-noir-2 transition-all cursor-default block no-underline cursor-pointer"
          (click)="onClick.emit()"
        >
          @if (svgType === 'svg') {
            <app-svg
              [svgPath]="'/assets/svg/' + svgName + '.svg'"
              [ngClass]="{
                'fg-vert-1': true,
                'text-white': false,
              }"
            ></app-svg>
          } @else if (svgType === 'material') {
            <span
              class="material-icons !text-md"
              [ngClass]="{
                'fg-vert-1': true,
                'text-white': false,
              }"
            >
              {{ svgName }}
            </span>
          } @else if (svgType === 'material-symbols-outlined') {
            <span
              class="material-symbols-outlined !text-md "
              [ngClass]="{
                'fg-vert-1': true,
                'text-white': false,
              }"
            >
              {{ svgName }}
            </span>
          }
          @if (!isCollapsed) {
            <span class="text-white text-xs font-semibold">{{
              label | translate
            }}</span>
          }
        </div>
      }
    </div>
  `,
})
export class NavbarButtonComponent {
  @Input({ required: true }) label!: string;
  @Input({ required: true }) svgName!: string;
  @Input({ required: true }) isCollapsed!: boolean;
  @Input() url: string | undefined;
  @Input() svgType: 'svg' | 'material' | 'material-symbols-outlined' = 'svg';

  @Output() onClick = new EventEmitter<void>();

  constructor() {}
}
